<app-content-container [isLoading]="isSummaryStepLoading$ | async" [error]="summaryStepError$ | async">
  <div class="grid">
    <app-wizard-order-summary
      *ngIf="(isLgAndAbove$ | async) !== true"
      class="col-12"
      [useForSubmission]="true"
    ></app-wizard-order-summary>
    <p-card class="col-12 lg:col-7">
      <app-summary-widget
        *ngIf="!(skipBillingStep$ | async)?.value"
        stepKey="billing"
        title="Payment Method"
        [disableChange]="(selectedPaymentMethod$ | async) === null"
      >
        <app-payment-method-details
          *ngIf="selectedPaymentMethod$ | async"
          [paymentMethod]="(selectedPaymentMethod$ | async)!"
          data-cy="payment-method-content"
        ></app-payment-method-details>
        <div
          *ngIf="(selectedPaymentMethod$ | async) === null"
          class="empty-payment-method-container border-grey-100 py-4 px-4 sm:px-7 border-1"
          data-cy="no-payment-method-content"
        >
          <button
            pButton
            type="button"
            label="Add your payment method"
            icon="mi-round mi-add-circle-outline"
            class="p-button-text p-button-sm"
            data-cy="add-new-payment-method-button"
            (click)="navigateToBillingStep()"
            appClickEvent
            eventName="order_wizard_add_payment_method"
          ></button>
        </div>
      </app-summary-widget>
      <app-summary-widget stepKey="contacts" title="Shipping">
        <p
          class="p3 m-0"
          [innerHtml]="(reorder$ | async)?.shippingAddress | formatAddress"
          data-cy="shipping-content"
        ></p>
      </app-summary-widget>
      <app-summary-widget stepKey="products" title="Products">
        <app-product-details
          [items]="(reorderItemsSummary$ | async) || []"
          data-cy="products-content"
        ></app-product-details>
      </app-summary-widget>
      <app-summary-widget
        stepKey="insurance"
        title="Insurance"
        [pendingVerification]="(insurancePendingVerification$ | async) || false"
      >
        <h3 class="mt-0 mb-3" data-cy="primary-insurance-heading">Primary Insurance</h3>
        <app-insurance-details
          [insurance]="(insurance$ | async)?.primaryInsurance!"
          data-cy="primary-insurance-details"
        ></app-insurance-details>
        <div *ngIf="(insurance$ | async)?.secondaryInsurance">
          <h3 class="mt-5 mb-3" data-cy="secondary-insurance-heading">Secondary Insurance</h3>
          <app-insurance-details
            [insurance]="(insurance$ | async)?.secondaryInsurance!"
            data-cy="secondary-insurance-details"
          ></app-insurance-details>
        </div>
      </app-summary-widget>
      <app-summary-widget
        stepKey="provider"
        title="Provider"
        [noMargin]="true"
        *ngIf="(selectedProvider$ | async)?.provider"
        [pendingVerification]="(providerPendingVerification$ | async) || false"
      >
        <p
          class="my-0 p3 font-semibold"
          [innerHtml]="'Dr. ' + (selectedProvider$ | async)?.provider?.fullName | titlecase"
          data-cy="provider-name"
        ></p>
        <p
          class="p3 my-2"
          [innerHtml]="(selectedProvider$ | async)?.provider?.phoneNumber | formatPhone"
          data-cy="provider-phone"
        ></p>
        <p
          class="p3 my-0"
          [innerHtml]="(selectedProvider$ | async)?.provider?.address | formatAddress: { singleLine: true }"
          data-cy="provider-address"
        ></p>
        <div *ngIf="(selectedProvider$ | async)?.nextProviderVisit">
          <p
            class="p3 font-semibold mt-4 mb-0"
            [innerHtml]="'Future Provider Visit'"
            data-cy="next-provider-visit-heading"
          ></p>
          <p
            class="p3 p3 mt-1 mb-0"
            [innerHtml]="(selectedProvider$ | async)?.nextProviderVisit | formatDate"
            data-cy="next-provider-visit-date"
          ></p>
        </div>
        <div *ngIf="!(selectedProvider$ | async)?.nextProviderVisit && (selectedProvider$ | async)?.lastProviderVisit">
          <p
            class="p3 font-semibold mt-4 mb-0"
            [innerHtml]="'Last Provider Visit'"
            data-cy="last-provider-visit-heading"
          ></p>
          <p
            class="p3 mt-1 mb-0"
            [innerHtml]="(selectedProvider$ | async)?.lastProviderVisit | formatDate"
            data-cy="last-provider-visit-date"
          ></p>
        </div>
      </app-summary-widget>
    </p-card>
    <div *ngIf="isLgAndAbove$ | async" class="block col-5 flex align-items-start">
      <div class="sticky-order-summary-container block">
        <app-wizard-order-summary [useForSubmission]="true"></app-wizard-order-summary>
      </div>
    </div>
  </div>
</app-content-container>
